import React from "react";
import Navbar from "../components/Navbar";
import "../styles/global.css";
import Products from "../components/Products";
import Footer from "../components/Footer";
import { Helmet } from "react-helmet-async";
import { useParams } from "react-router";
import ProductsData from "../data/products.json";
import seoFriendlySlug from "../utils/seoFriendlySlug";

const ProductsPage = () => {
  const { category, subcategory, product } = useParams();
  console.log("product------>", product);
  const categoryData = ProductsData.products.find((prod) => {
    // console.log(prod.categoryName.toLowerCase(), category.toLowerCase().replace(/-/g, ' '))
    return (
      prod.categoryName.toLowerCase() ===
      category.toLowerCase().replace(/-/g, " ")
    );
  });

  if (!categoryData) {
    return <p>Category not found</p>;
  }

  const subCategoryData = categoryData.subCategories.find((sub) => {
    const formattedSubCategoryName = sub.subCategoryName
      .toLowerCase()
      .replace(/\//g, " ");

    return (
      seoFriendlySlug(sub.subCategoryName) === seoFriendlySlug(subcategory)
    );
  });

  if (!subCategoryData) {
    return <p>Subcategory not found</p>;
  }

  const productData = subCategoryData.products.find((prod) => {
    const fixedProductName = encodeURIComponent(
      prod.productName.replace(/[,/]/g, "-").replace(/\//g, "-").toLowerCase()
    ); // Removes %2X (e.g., %20, %2C, etc.)

 

    return (seoFriendlySlug(prod.productName) === seoFriendlySlug(product));
  });

  console.log("====}");

  if (!productData) {
    return <p>Product not found1</p>;
  }

  return (
    <>
      <Helmet>
        <title>{`${product}`} | TimeWatch Infocom</title>
        {productData.prodesc && (
          <meta name="description" content={productData.prodesc}></meta>
        )}
        {productData.keywords && productData.keywords.length > 0 && (
          <meta
            name="keywords"
            content={productData.keywords.join(", ")}
          ></meta>
        )}
        <link
          rel="canonical"
          href={`https://www.timewatchindia.com/market-place/${category}/${subcategory}/${product}`}
        ></link>
      </Helmet>
      <header className="navbar">
        <Navbar />
      </header>

      <div className="content-container">
        <section className="product">
          <Products />
        </section>
      </div>

      <footer className="footer">
        <Footer />
      </footer>
    </>
  );
};

export default ProductsPage;
